@if (impactdata | async ; as item) {
  <div  class="bottombox">
    @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp1'  && screenvalue==1) {
      <div  class="impactbox">
        <div [innerHtml]="item?.largeparagraphcontent"></div>
      </div>
    }
    @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp1'  && screenvalue==1) {
      <div class="reference_Container">
        @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp1'  && screenvalue==1) {
          <div class="reference" [innerHtml]="item?.content"></div>
        }
        @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp1'  && screenvalue==1) {
          <div class="uptk_Disclaimer" [innerHTML]="item?.reference"></div>
        }
      </div>
    }
    @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp2'  && screenvalue==2) {
      <div  class="impactbox">
        <div [innerHtml]="item?.largeparagraphcontent"></div>
      </div>
    }
    @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp2'  && screenvalue==2) {
      <div class="reference_Container">
        @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp2'  && screenvalue==2) {
          <div class="reference" [innerHtml]="item?.content"></div>
        }
        @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp2'  && screenvalue==2) {
          <div class="uptk_Disclaimer" [innerHTML]="item?.reference"></div>
        }
      </div>
    }
    @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp3'  && screenvalue==3) {
      <div  class="impactbox">
        <div [innerHtml]="item?.largeparagraphcontent"></div>
      </div>
    }
    @if (item.uid=='SeqirusUptakeAcceleratorDetailBottomComp3'  && screenvalue==3) {
      <div class="uptk_Disclaimer_Screen3" [innerHTML]="item?.reference"></div>
    }
  </div>
}
